import { ButtonType, ButtonWidget } from '@tableau/widgets';
import { Formik, FormikHelpers, FormikProps } from 'formik';

import { Messages } from '~src/codegen/Localize';
import React = require('react');
import { LoginUrlsWrapper } from '~src/app/spaces/Login/LoginUrls';
import { CommonStyles } from '~src/common/react/CommonStyles';
import { FormikTextBox } from '~src/commonInfra/components/FormikField';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { AuthenticationService } from '../services/AuthenticationService';
import { LoginPageStyles } from '../styles/LoginPageStyles';

export interface TokenProps {
    token: string;
}

interface TokenRequestFormFields {
    newPassword: string;
    confirmPassword: string;
}

const buttonStyle: React.CSSProperties = {
    marginTop: CommonStyles.Sizes.XLargeSpace - CommonStyles.Sizes.DefaultSpace,
};

export function ResetPasswordWithTokenForm(props: TokenProps) {

    function validateNewPassword(value: string): string | undefined {
        if (!value) {
            return Messages.enterYourPassword();
        }
    }

    function validateConfirmPassword(confirmPassword: string, values: TokenRequestFormFields): string {
        if (confirmPassword && values.newPassword !== confirmPassword) {
            return Messages.passwordsDoNotMatch();
        }
    }

    function handleFailure(errorCode: number) {
        LoginUrlsWrapper.navigateToSignIn({
            error: errorCode
        });
    }

    function sendPasswordResetRequest(formProps: TokenRequestFormFields, formik: FormikHelpers<any>): void {
        AuthenticationService.sendPasswordResetRequest('', '', formProps.newPassword, props.token)
            .then((resetPasswordResult: IResult) => {
                LoginUrlsWrapper.navigateToSignIn({
                    passwordResetSuccess: true
                });
            }, (errorCode: number) => {
                handleFailure(errorCode);
            });
    }

    return (<Formik
        initialValues={{ newPassword: '', confirmPassword: '' }}
        onSubmit={(values: TokenRequestFormFields, formik: FormikHelpers<any>) => {
            sendPasswordResetRequest(values, formik);
        }}
        enableReinitialize={true}
    >
        {(formik: FormikProps<TokenRequestFormFields>) => (
            <form name='passwordResetForm' autoComplete='off' noValidate onSubmit={formik.handleSubmit} data-tb-test-id='passwordResetForm'>
                <div className='tb-login-text-box tb-padded'>
                    <FormikTextBox
                        name='newPassword'
                        required={true}
                        label={Messages.newPassword()}
                        type={'password'}
                        className={LoginPageStyles.textboxStyle}
                        validate={validateNewPassword}
                        showValidationMessage={true}
                        eagerValidation={true}
                        testId='textbox-password'
                        onClear={() => formik.setFieldValue('newPassword', '')} />
                </div>
                <div className='tb-login-text-box tb-padded'>
                    <FormikTextBox
                        name='confirmPassword'
                        required={true}
                        label={Messages.confirmPassword()}
                        type={'password'}
                        className={LoginPageStyles.textboxStyle}
                        validate={
                            (value: string) => validateConfirmPassword(value, formik.values)
                        }
                        showValidationMessage={true}
                        eagerValidation={true}
                        testId='textbox-confirm'
                        onClear={() => formik.setFieldValue('confirmPassword', '')} />
                </div>
                <ButtonWidget buttonType={ButtonType.Outline}
                    type='submit'
                    style={buttonStyle}
                    tb-test-id="button-reset"
                    testId='btn-reset'
                    disabled={!formik.values.newPassword || !formik.values.confirmPassword || !formik.isValid}
                    className={LoginPageStyles.submitButtonStyle}>
                    {Messages.resetPassword()}
                </ButtonWidget>
            </form>
        )}
    </Formik>);
}